<template>
  <ShoppingCartItem :item-id="shoppingCartItem.id!" :minimal>
    <template #description>
      {{ shoppingCartItem.domain!.fqdn }}
    </template>

    <template #price>
      <div :class="['flex flex-col items-start space-y-1 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-2']">
        <TldPriceDisplay :tld="shoppingCartItem.domain!.tld!" />
      </div>
    </template>

    <template #addons>
      <div
        v-if="
          cart.items.filter((i) => i.parentItemId === shoppingCartItem.id)
            .length === 0
        "
      >
        <UButton
          v-if="!minimal"
          color="gray"
          variant="solid"
          size="xs"
          :to="`/domene/tilleggstjenester/${shoppingCartItem.domain!.fqdn}`"
          >Legg til tilleggstjeneste</UButton
        >
      </div>

      <template v-else>
        <ShoppingCartDomainAddOnItem
          v-for="addon in cart.items.filter(
            (i) => i.parentItemId === shoppingCartItem.id
          )"
          :minimal
          :cart-item-id="addon.id!"
          :add-on-id="addon.addOn?.addOnId!"
          :class="[!minimal && 'pr-16']"
        />

        <UButton
          v-if="!minimal"
          color="gray"
          variant="solid"
          class="mt-2"
          size="xs"
          :to="`/domene/tilleggstjenester/${shoppingCartItem.domain!.fqdn}`"
          >Endre tilleggstjenester</UButton
        >
      </template>
    </template>
  </ShoppingCartItem>
</template>

<script lang="ts" setup>
const cart = useCartStore();

const props = defineProps<{
  minimal: boolean;
  shoppingCartItem: (typeof cart.items)[0];
}>();
</script>

<style></style>
